import {Box, Fab, Typography} from "@mui/material";
import {useTheme} from "../../contexts/theme";
import footerLogo from "../../assets/images/Matchboard/kebula_new_full_white.svg"
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import headerLogo from "../../assets/images/Login/inbriefFullWhiteR.svg";
import React from "react";
import {useNavigate} from "react-router-dom";


export const Footer = ({}) => {


    const theme = useTheme();
    const navigate = useNavigate();


    return (
        <Box className="box-container" sx={{
            display: 'flex',
            justifyContent: 'center',
            height: '100%',
            width: '100%',
            alignItems: 'center',
            padding: theme.spacing.sm
        }}>
            {<img src={headerLogo} onClick={() => navigate('/matchboard')} style={{
                maxWidth: 'auto',
                height: '75%',
            }}></img>}


            {/*<Box
                sx={{
                    position: 'fixed',
                    bottom: 16,
                    right: 100,
                }}
            >
                <Fab sx={{backgroundColor: theme.palette.orange}} aria-label="up">
                    <ArrowDropUpIcon sx={{color: theme.palette.white}}/>
                </Fab>
            </Box>*/}
        </Box>
    );
}
